module.exports = __webpack_public_path__ + "img/tf24.9d492d84.png";